import { useNavigate } from "react-router";

import { CreateClientCard } from "@components/Cards/CreateClientCard/CreateClientCard";

import { routes } from "@pages/routes";

export const CreateClient = () => {
  const navigate = useNavigate();

  const handleCreateClientSuccess = () => {
    navigate(routes.portal.clients.$path(), { viewTransition: true });
  };

  return <CreateClientCard onCreateClientSuccess={handleCreateClientSuccess} />;
};
